import React, { useState, useMemo } from "react";
import "./index.css";
import section2img from "../assests/HomeImg/section2-img.svg";

// Presentations PDFs
import AGM36 from "../assests/Financials/Presentations/36th AGM Presentation.pdf";
import AGM35 from "../assests/Financials/Presentations/35th AGM Presentation.pdf";
import InvestorsPresentationNov2019 from "../assests/Financials/Presentations/Investors Presentation Nov 2019.pdf";
import AGM34 from "../assests/Financials/Presentations/34th AGM Presentation.pdf";
import InvestorsPresentationMay2019 from "../assests/Financials/Presentations/Investors Presentation May 2019.pdf";
import InvestorsPresentationFeb2019 from "../assests/Financials/Presentations/Investors Presentation February 2019.pdf";
import InvestorsPresentationNov2018 from "../assests/Financials/Presentations/Investors Presentation November 2018.pdf";
import InvestorsPresentationSept2018 from "../assests/Financials/Presentations/Investors Presentation September 2018.pdf";
import InvestorPresentationAGMSept2018 from "../assests/Financials/Presentations/Investor Presentation AGM September 27, 2018.pdf";
import InvestorsPresentationAug2018 from "../assests/Financials/Presentations/Investors Presentation August 2018.pdf";
import InvestorsPresentationJune2018 from "../assests/Financials/Presentations/Investors Presentation June 2018.pdf";
import InvestorsPresentationMarch2018 from "../assests/Financials/Presentations/Investors Presentation March 2018.pdf";
import InvestorsPresentationJan2018 from "../assests/Financials/Presentations/Investors Presentation January 2018.pdf";
import InvestorsPresentationNov2017 from "../assests/Financials/Presentations/Investors Presentation November 2017.pdf";
import InvestorsPresentationSept2017 from "../assests/Financials/Presentations/Investors Presentation September 26, 2017.pdf";
import InvestorsPresentationSept2016 from "../assests/Financials/Presentations/Investors Presentation September 22, 2016.pdf";
import AGM2015_16 from "../assests/Financials/Presentations/AGM Presentation 2015-16.pdf";
import GeneralMeetingPresentation from "../assests/Financials/Presentations/General Meeting Presentation.pdf";
import CorporatePresentation from "../assests/Financials/Presentations/Corporate Presentation.pdf";
import InvestorsPresentation from "../assests/Financials/Presentations/Investors Presentation.pdf";

// Quarterly Financial Files
import InvestorPresentationQ42526 from "../assests/Financials/QuarterlyFinancial/Investor-Presentation-Q4-2526.pdf";
import IFQF4 from "../assests/Financials/QuarterlyFinancial/IFQF4-Quarterly_Financial_4.pdf";
import QF1 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_1.pdf";
import QF2 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_2.mp3";
import QF3 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_3.pdf";
import QF4 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_4.pdf";
import QF5 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_5.pdf";
import QF6 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_6.pdf";
import QF7 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_7.pdf";
import QF8 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_8.mp3";
import QF9 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_9.pdf";
import QF10 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_10.pdf";
import QF11 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_11.pdf";
import QF12 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_12.pdf";
import QF13 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_13.pdf";
import QF14 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_14.mp3";
import QF15 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_15.pdf";
import QF16 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_16.pdf";
import QF17 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_17.pdf";
import QF18 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_18.pdf";
import QF19 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_19.mp3";
import QF20 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_20.pdf";
import QF21 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_21.pdf";
import QF22 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_22.pdf";
import QF23 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_23.pdf";
import QF24 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_24.mp3";
import QF25 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_25.pdf";
import QF26 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_26.pdf";
import QF27 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_27.pdf";
import QF28 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_28.pdf";
import QF29 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_29.pdf";
import QF30 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_30.pdf";
import QF31 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_31.pdf";
import QF32 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_32.mp3";
import QF33 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_33.pdf";
import QF34 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_34.mp3";
import QF35 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_35.pdf";
import QF36 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_36.pdf";
import QF37 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_37.pdf";
import QF38 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_38.pdf";
import QF39 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_39.mp3";
import QF40 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_40.pdf";
import QF41 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_41.pdf";
import QF42 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_42.pdf";
import QF43 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_43.mp3";
import QF44 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_44.pdf";
import QF45 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_45.pdf";
import QF46 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_46.pdf";
import QF47 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_47.mp3";
import QF48 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_48.pdf";
import QF49 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_49.pdf";
import QF50 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_50.pdf";
import QF51 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_51.mp3";
import QF52 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_52.pdf";
import QF53 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_53.pdf";
import QF54 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_54.pdf";
import QF55 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_55.mp3";
import QF56 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_56.pdf";
import QF57 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_57.pdf";
import QF58 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_58.pdf";
import QF59 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_59.mp3";
import QF60 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_60.pdf";
import QF61 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_61.pdf";
import QF62 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_62.pdf";
import QF63 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_63.mp3";
import QF64 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_64.pdf";
import QF65 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_65.pdf";
import QF66 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_66.pdf";
import QF67 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_67.mp3";
import QF68 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_68.pdf";
import QF69 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_69.pdf";
import QF70 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_70.pdf";
import QF71 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_71.pdf";
import QF72 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_72.pdf";
import QF73 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_73.pdf";
import QF74 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_74.pdf";
import QF75 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_75.pdf";
import QF76 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_76.pdf";
import QF77 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_77.pdf";
import QF78 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_78.pdf";
import QF79 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_79.pdf";
import QF80 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_80.mp3";
import QF81 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_81.pdf";
import QF82 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_82.pdf";
import QF83 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_83.pdf";
import QF84 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_84.pdf";
import QF85 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_85.pdf";
import QF86 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_86.pdf";
import QF87 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_87.pdf";
import QF88 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_88.pdf";
import QF89 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_89.pdf";
import QF90 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_90.pdf";
import QF91 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_91.pdf";
import QF92 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_92.pdf";
import QF93 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_93.pdf";
import QF94 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_94.pdf";
import QF95 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_95.pdf";
import QF96 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_96.pdf";
import QF97 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_97.pdf";
import QF98 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_98.pdf";
import QF99 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_99.pdf";
import QF100 from "../assests/Financials/QuarterlyFinancial/Quarterly_Financial_100.pdf";


import QF101 from "../assests/Financials/Presentations/Earnings-call-audio-recording0526.mp3";


import CallTranscripQ4 from "../assests/Financials/QuarterlyFinancial/CallTranscript-Q4.pdf";
import SF2627 from "../assests/Financials/QuarterlyFinancial/SignedFinancialsAugust.pdf";
import InvestorPresentationQ12627 from "../assests/Financials/QuarterlyFinancial/Investor-Presentation-Q1FY27.pdf";
import EarningsCallQ12627 from "../assests/Financials/QuarterlyFinancial/EarningsCallQ12627.mp3";






// Press Release Files
import Q4F526 from "../assests/Financials/PressRelease/Q4F526-Press_Releases_1.pdf";
import PR1 from "../assests/Financials/PressRelease/Press_Releases_1.pdf";
import PR2 from "../assests/Financials/PressRelease/Press_Releases_2.pdf";
import PR3 from "../assests/Financials/PressRelease/Press_Releases_3.pdf";
import PR4 from "../assests/Financials/PressRelease/Press_Releases_4.pdf";
import PR5 from "../assests/Financials/PressRelease/Press_Releases_5.pdf";
import PR6 from "../assests/Financials/PressRelease/Press_Releases_6.pdf";
import PR7 from "../assests/Financials/PressRelease/Press_Releases_7.pdf";
import PR8 from "../assests/Financials/PressRelease/Press_Releases_8.pdf";
import PR9 from "../assests/Financials/PressRelease/Press_Releases_9.pdf";
import PR10 from "../assests/Financials/PressRelease/Press_Releases_10.pdf";
import PR11 from "../assests/Financials/PressRelease/Press_Releases_11.pdf";
import PR12 from "../assests/Financials/PressRelease/Press_Releases_12.pdf";
import PR13 from "../assests/Financials/PressRelease/Press_Releases_13.pdf";
import PR14 from "../assests/Financials/PressRelease/Press_Releases_14.pdf";
import PR15 from "../assests/Financials/PressRelease/Press_Releases_15.pdf";
import PR16 from "../assests/Financials/PressRelease/Press_Releases_16.pdf";
import PR17 from "../assests/Financials/PressRelease/Press_Releases_17.pdf";
import PR18 from "../assests/Financials/PressRelease/Press_Releases_18.pdf";
import PR19 from "../assests/Financials/PressRelease/Press_Releases_19.pdf";
import PR20 from "../assests/Financials/PressRelease/Press_Releases_20.pdf";
import PR21 from "../assests/Financials/PressRelease/Press_Releases_21.pdf";
import PR22 from "../assests/Financials/PressRelease/Press_Releases_22.pdf";
import PR23 from "../assests/Financials/PressRelease/Press_Releases_23.pdf";
import PR24 from "../assests/Financials/PressRelease/Press_Releases_24.pdf";
import PR25 from "../assests/Financials/PressRelease/Press_Releases_25.pdf";
import PR26 from "../assests/Financials/PressRelease/Press_Releases_26.pdf";
import PR27 from "../assests/Financials/PressRelease/Press_Releases_27.pdf";
import PR28 from "../assests/Financials/PressRelease/Press_Releases_28.pdf";
import PR29 from "../assests/Financials/PressRelease/Press_Releases_29.pdf";
import PR30 from "../assests/Financials/PressRelease/Press_Releases_30.pdf";
import PR31 from "../assests/Financials/PressRelease/Press_Releases_31.pdf";
import PR32 from "../assests/Financials/PressRelease/Press_Releases_32.pdf";
import PR33 from "../assests/Financials/PressRelease/Press_Releases_33.pdf";
import PR34 from "../assests/Financials/PressRelease/Press_Releases_34.pdf";
import PR35 from "../assests/Financials/PressRelease/Press_Releases_35.pdf";
import PR36 from "../assests/Financials/PressRelease/Press_Releases_36.pdf";
import PR37 from "../assests/Financials/PressRelease/Press_Releases_37.pdf";
import PR38 from "../assests/Financials/PressRelease/Press_Releases_38.pdf";
import PR39 from "../assests/Financials/PressRelease/Press_Releases_39.pdf";
import PR40 from "../assests/Financials/PressRelease/Press_Releases_40.pdf";
import PR41 from "../assests/Financials/PressRelease/Press_Releases_41.pdf";
import PR42 from "../assests/Financials/PressRelease/Press_Releases_42.pdf";
import PR43 from "../assests/Financials/PressRelease/Press_Releases_43.pdf";
import PR44 from "../assests/Financials/PressRelease/Press_Releases_44.pdf";
import PR45 from "../assests/Financials/PressRelease/Press_Releases_45.pdf";
import PR46 from "../assests/Financials/PressRelease/Press_Releases_46.pdf";
import PR47 from "../assests/Financials/PressRelease/Press_Releases_47.pdf";
import PR48 from "../assests/Financials/PressRelease/Press_Releases_48.pdf";
import PR49 from "../assests/Financials/PressRelease/Press_Releases_49.pdf";
import PR50 from "../assests/Financials/PressRelease/Press_Releases_50.pdf";
import PR51 from "../assests/Financials/PressRelease/Press_Releases_51.pdf";
import PR52 from "../assests/Financials/PressRelease/Press_Releases_52.pdf";
import PR53 from "../assests/Financials/PressRelease/Press_Releases_53.pdf";
import PR54 from "../assests/Financials/PressRelease/Press_Releases_54.pdf";
import PR55 from "../assests/Financials/PressRelease/Press_Releases_55.pdf";
import PR56 from "../assests/Financials/PressRelease/Press_Releases_56.pdf";
import PR57 from "../assests/Financials/PressRelease/Press_Releases_57.pdf";
import PR58 from "../assests/Financials/PressRelease/Press_Releases_58.pdf";
import PR59 from "../assests/Financials/PressRelease/Press_Releases_59.pdf";
import PR60 from "../assests/Financials/PressRelease/Press_Releases_60.pdf";
import PR61 from "../assests/Financials/PressRelease/Press_Releases_61.pdf";
import PR62 from "../assests/Financials/PressRelease/Press_Releases_62.pdf";
import PR63 from "../assests/Financials/PressRelease/Press_Releases_63.pdf";
import PR64 from "../assests/Financials/PressRelease/Press_Releases_64.pdf";
import PR65 from "../assests/Financials/PressRelease/Press_Releases_65.pdf";
import PR66 from "../assests/Financials/PressRelease/Press_Releases_66.pdf";
import PR67 from "../assests/Financials/PressRelease/Press_Releases_67.pdf";
import PR68 from "../assests/Financials/PressRelease/Press_Releases_68.pdf";
import PR69 from "../assests/Financials/PressRelease/Press_Releases_69.pdf";
import PR70 from "../assests/Financials/PressRelease/Press_Releases_70.pdf";
import PR71 from "../assests/Financials/PressRelease/Press_Releases_71.pdf";
import PR72 from "../assests/Financials/PressRelease/Press_Releases_72.pdf";
import PR73 from "../assests/Financials/PressRelease/Press_Releases_73.pdf";






const AudioIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 3V21M9 6L12 3L15 6M9 18L12 21L15 18M3 9H6L10 5V19L6 15H3V9Z" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15 9C16.5 10.5 16.5 13.5 15 15" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M18 6C20.5 8.5 20.5 15.5 18 18" stroke="#2563EB" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// ── SVG Icons ────────────────────────────────────────────────────────────────

const PdfIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" fill="#E53935" opacity="0.15" />
        <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" stroke="#E53935" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
        <path d="M14 2V8H20" stroke="#E53935" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 13H15M9 17H13" stroke="#E53935" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

const DownloadIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7 10L12 15L17 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 15V3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const CalendarIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
        <path d="M16 2V6M8 2V6M3 10H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const FilterIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 3H2L10 12.46V19L14 21V12.46L22 3Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const SearchIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2" />
        <path d="M21 21L16.65 16.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

const QuarterlyFinancialReport = [


    { title: "Earnings call audio recording", Quater: "Q1", period: "2026-2027", icon: <AudioIcon />, url: EarningsCallQ12627 },
    { title: "Investor Presentation", Quater: "Q1", period: "2026-2027", icon: <PdfIcon />, url: InvestorPresentationQ12627 },
    { title: "Signed Financials", Quater: "Q1", period: "2026-2027", icon: <PdfIcon />, url: SF2627 },



    { title: "Call Transcript", Quater: "Q4", period: "2025-2026", icon: <PdfIcon />, url: CallTranscripQ4 },
    { title: "Earnings call audio recording", Quater: "Q4", period: "2025-2026", icon: <AudioIcon />, url: QF101 },
    { title: "Investor Presentation", Quater: "Q4", period: "2025-2026", icon: <PdfIcon />, url: InvestorPresentationQ42526 },
    { title: "Signed Financials", Quater: "Q4", period: "2025-2026", icon: <PdfIcon />, url: IFQF4 },
    { title: "Call Transcript", Quater: "Q3", period: "2025-2026", icon: <PdfIcon />, url: QF1 },
    { title: "Earnings Call Recording", Quater: "Q3", period: "2025-2026", icon: <AudioIcon />, url: QF2 },
    { title: "Investor Presentation", Quater: "Q3", period: "2025-2026", icon: <PdfIcon />, url: QF3 },
    { title: "Signed Financials", Quater: "Q3", period: "2025-2026", icon: <PdfIcon />, url: QF4 },
    { title: "Revised Earnings Call Intimation", Quater: "Q3", period: "2025-2026", icon: <PdfIcon />, url: QF5 },
    { title: "Earnings Call Intimation", Quater: "Q3", period: "2025-2026", icon: <PdfIcon />, url: QF6 },
    { title: "Call Transcript", Quater: "Q2", period: "2025-2026", icon: <PdfIcon />, url: QF7 },
    { title: "Earning call Recording", Quater: "Q2", period: "2025-2026", icon: <AudioIcon />, url: QF8 },
    { title: "Revised Investor call conference Intimation Nov 19, 2025", Quater: "Q2", period: "2025-2026", icon: <PdfIcon />, url: QF9 },
    { title: "Investor Presentation Q2 FY26", Quater: "Q2", period: "2025-2026", icon: <PdfIcon />, url: QF10 },
    { title: "Signed Financials", Quater: "Q2", period: "2025-2026", icon: <PdfIcon />, url: QF11 },
    { title: "Investor call conferences Intimation Nov 17, 2025", Quater: "Q2", period: "2025-2026", icon: <PdfIcon />, url: QF12 },
    { title: "Call Transcript", Quater: "Q1", period: "2025-2026", icon: <PdfIcon />, url: QF13 },
    { title: "Earning call Audio Recording", Quater: "Q1", period: "2025-2026", icon: <AudioIcon />, url: QF14 },
    { title: "Signed Financials", Quater: "Q1", period: "2025-2026", icon: <PdfIcon />, url: QF15 },
    { title: "Investor Presentation Q1 FY26", Quater: "Q1", period: "2025-2026", icon: <PdfIcon />, url: QF16 },
    { title: "Investor call conference intimation Aug 11, 2025", Quater: "Q1", period: "2025-2026", icon: <PdfIcon />, url: QF17 },
    { title: "Call Transcript", Quater: "Q4", period: "2024-2025", icon: <PdfIcon />, url: QF18 },
    { title: "Earning Call Audio Recording", Quater: "Q4", period: "2024-2025", icon: <AudioIcon />, url: QF19 },
    { title: "Investor Presentation Q4 FY 25", Quater: "Q4", period: "2024-2025", icon: <PdfIcon />, url: QF20 },
    { title: "Financial Results FY 2024-25", Quater: "Q4", period: "2024-2025", icon: <PdfIcon />, url: QF21 },
    { title: "Investor Conference intimation 21st May 2025", Quater: "Q4", period: "2024-2025", icon: <PdfIcon />, url: QF22 },
    { title: "Call transcript", Quater: "Q3", period: "2024-2025", icon: <PdfIcon />, url: QF23 },
    { title: "Investor Call Recording", Quater: "Q3", period: "2024-2025", icon: <AudioIcon />, url: QF24 },
    { title: "Newspaper Publication for Q3 Financial results", Quater: "Q3", period: "2024-2025", icon: <PdfIcon />, url: QF25 },
    { title: "Financials", Quater: "Q3", period: "2024-2025", icon: <PdfIcon />, url: QF26 },
    { title: "Investor Presentation", Quater: "Q3", period: "2024-2025", icon: <PdfIcon />, url: QF27 },
    { title: "Call transcript", Quater: "Q2", period: "2024-2025", icon: <PdfIcon />, url: QF28 },
    { title: "Newspaper", Quater: "Q2", period: "2024-2025", icon: <PdfIcon />, url: QF29 },
    { title: "Financial", Quater: "Q2", period: "2024-2025", icon: <PdfIcon />, url: QF30 },
    { title: "Investor presentation", Quater: "Q2", period: "2024-2025", icon: <PdfIcon />, url: QF31 },
    { title: "Investor call recording", Quater: "Q2", period: "2024-2025", icon: <AudioIcon />, url: QF32 },
    { title: "Call Transcript", Quater: "Q1", period: "2024-2025", icon: <PdfIcon />, url: QF33 },
    { title: "Earnings Call Audio Recording", Quater: "Q1", period: "2024-2025", icon: <AudioIcon />, url: QF34 },
    { title: "Earning Presentation", Quater: "Q1", period: "2024-2025", icon: <PdfIcon />, url: QF35 },
    { title: "Signed Financials", Quater: "Q1", period: "2024-2025", icon: <PdfIcon />, url: QF36 },
    { title: "Signed Financials", Quater: "Q1", period: "2023-2024", icon: <PdfIcon />, url: QF37 },
    { title: "Earning Presentation", Quater: "Q1", period: "2023-2024", icon: <PdfIcon />, url: QF38 },
    { title: "Earnings Call Audio Recording", Quater: "Q1", period: "2023-2024", icon: <AudioIcon />, url: QF39 },
    { title: "Call Transcript", Quater: "Q1", period: "2023-2024", icon: <PdfIcon />, url: QF40 },
    { title: "Signed Financials", Quater: "Q2", period: "2023-2024", icon: <PdfIcon />, url: QF41 },
    { title: "Earning Presentation", Quater: "Q2", period: "2023-2024", icon: <PdfIcon />, url: QF42 },
    { title: "Earnings Call Audio Recording", Quater: "Q2", period: "2023-2024", icon: <AudioIcon />, url: QF43 },
    { title: "Call Transcript", Quater: "Q2", period: "2023-2024", icon: <PdfIcon />, url: QF44 },
    { title: "Signed Financials", Quater: "Q3", period: "2023-2024", icon: <PdfIcon />, url: QF45 },
    { title: "Earning Presentation", Quater: "Q3", period: "2023-2024", icon: <PdfIcon />, url: QF46 },
    { title: "Earnings Call Audio Recording", Quater: "Q3", period: "2023-2024", icon: <AudioIcon />, url: QF47 },
    { title: "Call Transcript", Quater: "Q3", period: "2023-2024", icon: <PdfIcon />, url: QF48 },
    { title: "Signed Financials", Quater: "Q4", period: "2023-2024", icon: <PdfIcon />, url: QF49 },
    { title: "Earning Presentation", Quater: "Q4", period: "2023-2024", icon: <PdfIcon />, url: QF50 },
    { title: "Earnings Call Audio Recording", Quater: "Q4", period: "2023-2024", icon: <AudioIcon />, url: QF51 },
    { title: "Call Transcript", Quater: "Q4", period: "2023-2024", icon: <PdfIcon />, url: QF52 },
    { title: "Signed Financials", Quater: "Q1", period: "2022-2023", icon: <PdfIcon />, url: QF53 },
    { title: "Earning Presentation", Quater: "Q1", period: "2022-2023", icon: <PdfIcon />, url: QF54 },
    { title: "Earnings Call Audio Recording", Quater: "Q1", period: "2022-2023", icon: <AudioIcon />, url: QF55 },
    { title: "Call Transcript", Quater: "Q1", period: "2022-2023", icon: <PdfIcon />, url: QF56 },
    { title: "Signed Financials", Quater: "Q2", period: "2022-2023", icon: <PdfIcon />, url: QF57 },
    { title: "Earning Presentation", Quater: "Q2", period: "2022-2023", icon: <PdfIcon />, url: QF58 },
    { title: "Earnings Call Audio Recording", Quater: "Q2", period: "2022-2023", icon: <AudioIcon />, url: QF59 },
    { title: "Call Transcript", Quater: "Q2", period: "2022-2023", icon: <PdfIcon />, url: QF60 },
    { title: "Signed Financials", Quater: "Q3", period: "2022-2023", icon: <PdfIcon />, url: QF61 },
    { title: "Earning Presentation", Quater: "Q3", period: "2022-2023", icon: <PdfIcon />, url: QF62 },
    { title: "Earnings Call Audio Recording", Quater: "Q3", period: "2022-2023", icon: <AudioIcon />, url: QF63 },
    { title: "Call Transcript", Quater: "Q3", period: "2022-2023", icon: <PdfIcon />, url: QF64 },
    { title: "Signed Financials", Quater: "Q4", period: "2022-2023", icon: <PdfIcon />, url: QF65 },
    { title: "Earning Presentation", Quater: "Q4", period: "2022-2023", icon: <PdfIcon />, url: QF66 },
    { title: "Earnings Call Audio Recording", Quater: "Q4", period: "2022-2023", icon: <AudioIcon />, url: QF67 },
    { title: "Call Transcript", Quater: "Q4", period: "2022-2023", icon: <PdfIcon />, url: QF68 },
    { title: "Signed Financials", Quater: "Q1", period: "2021-2022", icon: <PdfIcon />, url: QF69 },
    { title: "Earning Presentation", Quater: "Q1", period: "2021-2022", icon: <PdfIcon />, url: QF70 },
    { title: "Call Transcript", Quater: "Q1", period: "2021-2022", icon: <PdfIcon />, url: QF71 },
    { title: "Signed Financials", Quater: "Q2", period: "2021-2022", icon: <PdfIcon />, url: QF72 },
    { title: "Earning Presentation", Quater: "Q2", period: "2021-2022", icon: <PdfIcon />, url: QF73 },
    { title: "Call Transcript", Quater: "Q2", period: "2021-2022", icon: <PdfIcon />, url: QF74 },
    { title: "Signed Financials", Quater: "Q3", period: "2021-2022", icon: <PdfIcon />, url: QF75 },
    { title: "Earning Presentation", Quater: "Q3", period: "2021-2022", icon: <PdfIcon />, url: QF76 },
    { title: "Call Transcript", Quater: "Q3", period: "2021-2022", icon: <PdfIcon />, url: QF77 },
    { title: "Signed Financials", Quater: "Q4", period: "2021-2022", icon: <PdfIcon />, url: QF78 },
    { title: "Earning Presentation", Quater: "Q4", period: "2021-2022", icon: <PdfIcon />, url: QF79 },
    { title: "Earnings Call Audio Recording", Quater: "Q4", period: "2021-2022", icon: <AudioIcon />, url: QF80 },
    { title: "Call Transcript", Quater: "Q4", period: "2021-2022", icon: <PdfIcon />, url: QF81 },
    { title: "Signed Financials", Quater: "Q1", period: "2020-2021", icon: <PdfIcon />, url: QF82 },
    { title: "Earning Presentation", Quater: "Q1", period: "2020-2021", icon: <PdfIcon />, url: QF83 },
    { title: "Call Transcript", Quater: "Q1", period: "2020-2021", icon: <PdfIcon />, url: QF84 },
    { title: "Signed Financials", Quater: "Q2", period: "2020-2021", icon: <PdfIcon />, url: QF85 },
    { title: "Earning Presentation", Quater: "Q2", period: "2020-2021", icon: <PdfIcon />, url: QF86 },
    { title: "Call Transcript", Quater: "Q2", period: "2020-2021", icon: <PdfIcon />, url: QF87 },
    { title: "Signed Financials", Quater: "Q3", period: "2020-2021", icon: <PdfIcon />, url: QF88 },
    { title: "Earning Presentation", Quater: "Q3", period: "2020-2021", icon: <PdfIcon />, url: QF89 },
    { title: "Call Transcript", Quater: "Q3", period: "2020-2021", icon: <PdfIcon />, url: QF90 },
    { title: "Signed Financials", Quater: "Q4", period: "2020-2021", icon: <PdfIcon />, url: QF91 },
    { title: "Earning Presentation", Quater: "Q4", period: "2020-2021", icon: <PdfIcon />, url: QF92 },
    { title: "Call Transcript", Quater: "Q4", period: "2020-2021", icon: <PdfIcon />, url: QF93 },
    { title: "Signed Financials", Quater: "Q1", period: "2019-2020", icon: <PdfIcon />, url: QF94 },
    { title: "Earning Presentation", Quater: "Q1", period: "2019-2020", icon: <PdfIcon />, url: QF95 },
    { title: "Call Transcript", Quater: "Q1", period: "2019-2020", icon: <PdfIcon />, url: QF96 },
    { title: "Signed Financials", Quater: "Q2", period: "2019-2020", icon: <PdfIcon />, url: QF97 },
    { title: "Earning Presentation", Quater: "Q2", period: "2019-2020", icon: <PdfIcon />, url: QF98 },
    { title: "Call Transcript", Quater: "Q2", period: "2019-2020", icon: <PdfIcon />, url: QF99 },
    { title: "Signed Financials", Quater: "Q3", period: "2019-2020", icon: <PdfIcon />, url: QF100 }
];


const PressReleaseReport = [
    // 2025-2026
    { title: "Press Release on Audited Financials Q4 FY26", Quater: "Q4", period: "2025-2026", icon: <PdfIcon />, url: Q4F526 },
    { title: "Press release on Unaudited Financials Q3 FY26 (2025-26)", Quater: "Q3", period: "2025-2026", icon: <PdfIcon />, url: PR1 },
    { title: "Viyash Scientific announces partnership with Boehringer Ingelheim", period: "2025-2026", icon: <PdfIcon />, url: PR2 },
    { title: "Sequent -Viyash merger pronouncement of order by NCLT", period: "2025-2026", icon: <PdfIcon />, url: PR3 },
    { title: "SeQuent-Viyash Merger Receives Stock Exchange Approvals", period: "2025-2026", icon: <PdfIcon />, url: PR4 },

    // 2024-2025
    { title: "Press Release and Investor Presentation", period: "2024-2025", icon: <PdfIcon />, url: PR5 },
    { title: "Sequent Scientific Limited Receives Prequalification Approval from World Health Organization (WHO) for Albendazole API", period: "2024-2025", icon: <PdfIcon />, url: PR6 },
    { title: "SeQuent Scientific and Viyash Lifesciences Announce Strategic Merger to Create a Global Animal Health Leader with End-to-End Integrated Capabilities", period: "2024-2025", icon: <PdfIcon />, url: PR7 },

    // 2021-2022
    { title: "SeQuent Scientific Appoints Pharmaceutical Industry Leader Rajaram Narayanan as Managing Director and CEO", period: "2021-2022", icon: <PdfIcon />, url: PR8 },
    { title: "Acquisition of Nourrie", period: "2021-2022", icon: <PdfIcon />, url: PR9 },
    { title: "SeQuent announced EUGMP approval for its tablets dosage form in Turkey", period: "2021-2022", icon: <PdfIcon />, url: PR10 },

    // 2020-2021
    { title: "SeQuent Scientific Ltd Press Release Q4 FY21", period: "2020-2021", icon: <PdfIcon />, url: PR11 },
    { title: "SeQuent received CEP approval for Diclazuril API", period: "2020-2021", icon: <PdfIcon />, url: PR12 },
    { title: "Corporate update – December 22, 2020", period: "2020-2021", icon: <PdfIcon />, url: PR13 },
    { title: "Investors/analysts Conference Call – Corporate Update – December 22, 2020", period: "2020-2021", icon: <PdfIcon />, url: PR14 },
    { title: "SeQuent announced launch of Citramox® LA in EU", period: "2020-2021", icon: <PdfIcon />, url: PR15 },
    { title: "Launch of inhouse developed Halofusol® in EU", period: "2020-2021", icon: <PdfIcon />, url: PR16 },
    { title: "SeQuent Scientific Ltd PR Q2 FY21", period: "2020-2021", icon: <PdfIcon />, url: PR17 },
    { title: "SeQuent Announces Reconstitution of Board", period: "2020-2021", icon: <PdfIcon />, url: PR18 },
    { title: "SeQuent Scientific provides Covid-19 and Business Update", period: "2020-2021", icon: <PdfIcon />, url: PR19 },

    // 2019-2020
    { title: "Sequent Scientific announces WHO-Geneva approval for its Vizag facility", period: "2019-2020", icon: <PdfIcon />, url: PR20 },
    { title: "Sequent Scientific announces addition of new state-of-art Animal Health R&D Centre at Mumbai", period: "2019-2020", icon: <PdfIcon />, url: PR21 },
    { title: "SeQuent Scientific receives EIR from US FDA for its Analytical Laboratory at Bengaluru", period: "2019-2020", icon: <PdfIcon />, url: PR22 },
    { title: "Earnings Transcript May 14, 2019", period: "2019-2020", icon: <PdfIcon />, url: PR23 },
    { title: "SeQuent Scientific Announces Q4 and Annual FY19 Financial", period: "2019-2020", icon: <PdfIcon />, url: PR24 },
    { title: "Change in Credit Rating", period: "2019-2020", icon: <PdfIcon />, url: PR25 },

    // 2018-2019
    { title: "Earning Transcripts February 1, 2019", period: "2018-2019", icon: <PdfIcon />, url: PR26 },
    { title: "Sequent financials press release SeQuent Scientific Announces Q3 FY19 Financial Results", period: "2018-2019", icon: <PdfIcon />, url: PR27 },
    { title: "SeQuent Scientific Ltd. receives EIR from USDFA for its Analytical Lab at Mangalore", period: "2018-2019", icon: <PdfIcon />, url: PR28 },
    { title: "Earning Transcripts November 2, 2018", period: "2018-2019", icon: <PdfIcon />, url: PR29 },
    { title: "SeQuent Scientific Announces Q2 FY19 Financial Results", period: "2018-2019", icon: <PdfIcon />, url: PR30 },
    { title: "Earning Transcripts August 10 2018", period: "2018-2019", icon: <PdfIcon />, url: PR31 },
    { title: "SeQuent Scientific Announces Q1 FY19 Financial Results", period: "2018-2019", icon: <PdfIcon />, url: PR32 },

    // 2017-2018
    { title: "Sequent Scientific Earnings Transcript Q4 FY 18 Financial Results", period: "2017-2018", icon: <PdfIcon />, url: PR33 },
    { title: "SeQuent Scientific Announces Q4 FY18 Financial Results alongwith Investors Presentation", period: "2017-2018", icon: <PdfIcon />, url: PR34 },
    { title: "SeQuent Scientific Announces Q3 FY18 Financial Results", period: "2017-2018", icon: <PdfIcon />, url: PR35 },
    { title: "Sequent Scientific Announces Q2 FY 18 Financial Results", period: "2017-2018", icon: <PdfIcon />, url: PR36 },
    { title: "Sequent Scientific Announces Q1 FY 18 Financial Results", period: "2017-2018", icon: <PdfIcon />, url: PR37 },
    { title: "SeQuent Scientific announces FY17 Financial Results", period: "2017-2018", icon: <PdfIcon />, url: PR38 },
    { title: "Establishment Inspection Report – Visakhapatnam (Vizag) Plant", period: "2017-2018", icon: <PdfIcon />, url: PR39 },

    // 2016-2017
    { title: "SeQuent Scientific announces Q3FY17 Financial Results", period: "2016-2017", icon: <PdfIcon />, url: PR40 },
    { title: "SeQuent Scientific to become a pur-play Animal Health Company", period: "2016-2017", icon: <PdfIcon />, url: PR41 },
    { title: "SeQuent Scientific announces Q2FY17 Financial Results", period: "2016-2017", icon: <PdfIcon />, url: PR42 },
    { title: "SeQuent Scientific announces Q1FY17 Financial Results", period: "2016-2017", icon: <PdfIcon />, url: PR43 },
    { title: "Alivira completes the acquisition of 70% stake in Interchange, Brazil", period: "2016-2017", icon: <PdfIcon />, url: PR44 },
    { title: "Alivira to acquire majority stake in Karizoo Group Spain", period: "2016-2017", icon: <PdfIcon />, url: PR45 },
    { title: "SeQuent Scientific announces FY16 Financial Results", period: "2016-2017", icon: <PdfIcon />, url: PR46 },
    { title: "Alivira to acquire controlling interest in Interchange Brazil", period: "2016-2017", icon: <PdfIcon />, url: PR47 },

    // 2015-2016
    { title: "SeQuent Scientific Mahad Facility Receives Environment Clearance from SEIAA", period: "2015-2016", icon: <PdfIcon />, url: PR48 },
    { title: "SeQuent Scientific announces Q3FY16 Financial Results", period: "2015-2016", icon: <PdfIcon />, url: PR49 },
    { title: "Sequent Scientific to acquire controlling stake in Indo Phyto Chemicals Forays into steroids and hormones for Female Healthcare", period: "2015-2016", icon: <PdfIcon />, url: PR50 },
    { title: "Alivira forays into European Veterinary Market", period: "2015-2016", icon: <PdfIcon />, url: PR51 },
    { title: "Alivira to acquire Topkim, Turkey Will make Alivira the largest Animal Health Company of Turkey", period: "2015-2016", icon: <PdfIcon />, url: PR52 },
    { title: "SeQuent receives Establishment Inspection Report from US FDA for its API Drug Manufacturing Facility at Mangalore", period: "2015-2016", icon: <PdfIcon />, url: PR53 },
    { title: "SeQuent Scientific announces Q2FY16 Financial Results", period: "2015-2016", icon: <PdfIcon />, url: PR54 },
    { title: "SeQuent Scientific completes acquisition of Animal Health business of Lyka Exports", period: "2015-2016", icon: <PdfIcon />, url: PR55 },
    { title: "SeQuent Scientific to acquire Animal Health business of Lyka Exports", period: "2015-2016", icon: <PdfIcon />, url: PR56 },
    { title: "SeQuent Scientific announces Q1FY16 Financial Results", period: "2015-2016", icon: <PdfIcon />, url: PR57 },

    // 2014-2015
    { title: "SeQuent Scientific announces Q1FY16 Financial Results", period: "2014-2015", icon: <PdfIcon />, url: PR58 },
    { title: "SeQuent Scientific completes fund raise of INR 4,000 mn through Qualified Institutional Placement", period: "2014-2015", icon: <PdfIcon />, url: PR59 },
    { title: "SeQuent Scientific announces Q4 – FY 2014-15 Results", period: "2014-2015", icon: <PdfIcon />, url: PR60 },
    { title: "SeQuent Scientific announces Q3 – FY 2014-15 Results", period: "2014-2015", icon: <PdfIcon />, url: PR61 },
    { title: "SeQuent Scientific announces Q2 – FY 2014-15 Results", period: "2014-2015", icon: <PdfIcon />, url: PR62 },
    { title: "SeQuent Scientific announces Q1 – FY 2014-15 Results", period: "2014-2015", icon: <PdfIcon />, url: PR63 },

    // 2013-2014
    { title: "Sequent Scientific announces licensing agreement with Gilead Sciences, Inc for new Hepatitis C drug", period: "2013-2014", icon: <PdfIcon />, url: PR64 },
    { title: "Alivira Animal Health to acquire majority stake in Provet Veterinary Products AS of Turkey", period: "2013-2014", icon: <PdfIcon />, url: PR65 },
    { title: "SeQuent Scientific Limited announces completion of Sale of Specialty Chemicals division to Songwon Industrial Group", period: "2013-2014", icon: <PdfIcon />, url: PR66 },
    { title: "SeQuent Scientific announces FY 2013-14 Results", period: "2013-2014", icon: <PdfIcon />, url: PR67 },
    { title: "SeQuent Scientific to acquire the business of Arvee Synthesis", period: "2013-2014", icon: <PdfIcon />, url: PR68 },
    { title: "Songwon Industrial Group to acquire Specialty Chemicals Division of SeQuent Scientific Limited", period: "2013-2014", icon: <PdfIcon />, url: PR69 },
    { title: "SeQuent Scientific to acquire the business of Arvee Synthesis Acquisition to provide impetus to Human API business", period: "2013-2014", icon: <PdfIcon />, url: PR70 },
    { title: "Songwon Industrial Group to acquire Specialty Chemicals Division of SeQuent Scientific Limited", period: "2013-2014", icon: <PdfIcon />, url: PR71 },

    // 2012-2013
    { title: "Sequent Scientific Ltd & Shasun Pharmaceuticals Ltd Announce Joint Venture To Create Leading Animal Health Company", period: "2012-2013", icon: <PdfIcon />, url: PR72 },
    { title: "Sequent Scientific Receives Us Fda Approval For Its Api Drug Manufacturing Facility At Mangalore", period: "2012-2013", icon: <PdfIcon />, url: PR73 },
];


const PresentationsRepost = [
    { title: "36th AGM Presentation", icon: <PdfIcon />, url: AGM36 },
    { title: "35th AGM Presentation", icon: <PdfIcon />, url: AGM35 },
    { title: "Investors Presentation Nov 2019", icon: <PdfIcon />, url: InvestorsPresentationNov2019 },
    { title: "34th AGM Presentation", icon: <PdfIcon />, url: AGM34 },
    { title: "Investors Presentation May 2019", icon: <PdfIcon />, url: InvestorsPresentationMay2019 },
    { title: "Investors Presentation February 2019", icon: <PdfIcon />, url: InvestorsPresentationFeb2019 },
    { title: "Investors Presentation November 2018", icon: <PdfIcon />, url: InvestorsPresentationNov2018 },
    { title: "Investors Presentation September 2018", icon: <PdfIcon />, url: InvestorsPresentationSept2018 },
    { title: "Investor Presentation AGM September 27, 2018", icon: <PdfIcon />, url: InvestorPresentationAGMSept2018 },
    { title: "Investors Presentation August 2018", icon: <PdfIcon />, url: InvestorsPresentationAug2018 },
    { title: "Investors Presentation June 2018", icon: <PdfIcon />, url: InvestorsPresentationJune2018 },
    { title: "Investors Presentation March 2018", icon: <PdfIcon />, url: InvestorsPresentationMarch2018 },
    { title: "Investors Presentation January 2018", icon: <PdfIcon />, url: InvestorsPresentationJan2018 },
    { title: "Investors Presentation November 2017", icon: <PdfIcon />, url: InvestorsPresentationNov2017 },
    { title: "Investors Presentation September 26, 2017", icon: <PdfIcon />, url: InvestorsPresentationSept2017 },
    { title: "Investors Presentation September 22, 2016", icon: <PdfIcon />, url: InvestorsPresentationSept2016 },
    { title: "AGM Presentation 2015-16", icon: <PdfIcon />, url: AGM2015_16 },
    { title: "General Meeting Presentation", icon: <PdfIcon />, url: GeneralMeetingPresentation },
    { title: "Corporate Presentation", icon: <PdfIcon />, url: CorporatePresentation },
    { title: "Investors Presentation", icon: <PdfIcon />, url: InvestorsPresentation }
];


const Financial = () => {
    const [activeTab, setActiveTab] = useState("Quarterly Financial");
    const [selectedYear, setSelectedYear] = useState("All");
    const [selectedQuarter, setSelectedQuarter] = useState("All");
    const [searchQuery, setSearchQuery] = useState("");

    const tabs = [
        { id: "Quarterly Financial", label: "Quarterly Financial", count: QuarterlyFinancialReport.length },

        { id: "Press Release", label: "Press Release", count: PressReleaseReport.length },
        { id: "Presentation", label: "Presentation", count: PresentationsRepost.length },

    ];

    const getActiveData = () => {
        switch (activeTab) {
            case "Quarterly Financial": return QuarterlyFinancialReport;
            case "Press Release": return PressReleaseReport;
            case "Presentation": return PresentationsRepost;
            default: return [];
        }
    };

    const activeData = getActiveData();

    const uniqueYears = useMemo(() => {
        const allPeriods = activeData.map(r => r.period).filter(Boolean);
        return ["All", ...Array.from(new Set(allPeriods)).sort().reverse()];
    }, [activeTab]);

    const uniqueQuarters = ["All", "Q1", "Q2", "Q3", "Q4"];

    const hasYearFilter = activeTab !== "Presentation";
    const hasQuarterFilter = activeTab === "Quarterly Financial" || activeTab === "Shareholding Pattern";

    const filteredReports = useMemo(() => {
        return activeData.filter(report => {
            const searchMatch = !searchQuery || report.title.toLowerCase().includes(searchQuery.toLowerCase());

            if (!hasYearFilter) return searchMatch;

            const yearMatch = selectedYear === "All" || report.period === selectedYear;
            const quarterMatch = !hasQuarterFilter || selectedQuarter === "All" || (report.Quater ? report.Quater === selectedQuarter : true);
            return yearMatch && quarterMatch && searchMatch;
        });
    }, [activeData, selectedYear, selectedQuarter, hasYearFilter, hasQuarterFilter, searchQuery]);

    const groupedReports = useMemo(() => {
        if (!hasYearFilter || selectedYear !== "All" || searchQuery) return null;
        const groups = {};
        filteredReports.forEach(report => {
            const key = report.period || "Other";
            if (!groups[key]) groups[key] = [];
            groups[key].push(report);
        });
        return Object.entries(groups).sort((a, b) => {
            if (a[0] === "Other") return 1;
            if (b[0] === "Other") return -1;
            return b[0].localeCompare(a[0]);
        });
    }, [filteredReports, hasYearFilter, selectedYear, searchQuery]);

    const handleTabChange = (tabId) => {
        setActiveTab(tabId);
        setSelectedYear("All");
        setSelectedQuarter("All");
        setSearchQuery("");
    };

    const getQuarterColor = (quarter) => {
        switch (quarter) {
            case "Q1": return { bg: "#EFF6FF", text: "#2563EB", border: "#BFDBFE" };
            case "Q2": return { bg: "#F0FDF4", text: "#16A34A", border: "#BBF7D0" };
            case "Q3": return { bg: "#FFF7ED", text: "#EA580C", border: "#FED7AA" };
            case "Q4": return { bg: "#FAF5FF", text: "#9333EA", border: "#E9D5FF" };
            default: return { bg: "#F3F4F6", text: "#6B7280", border: "#E5E7EB" };
        }
    };

    return (
        <div className="financial-page">
            {/* ── HERO (original centered layout) ── */}
            <section className="fin-hero">
                <div className="fin-hero-content">
                    <h1>Financials</h1>
                    <img src={section2img} alt="Pharma Lab" className="home-section2-image" />
                    {/* <p>Sequent Scientific Limited is India's leading animal health company.</p> */}
                </div>
            </section>

            {/* TABS - NOW STICKY */}
            <div className="fin-tabs-strip">
                <nav className="fin-tabs">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            className={`fin-tab ${activeTab === tab.id ? "active" : ""}`}
                            onClick={() => handleTabChange(tab.id)}
                        >
                            <span className="fin-tab-label">{tab.label}</span>
                            {/* <span className="fin-tab-count">{tab.count}</span> */}
                        </button>
                    ))}
                </nav>
            </div>

            {/* CONTENT */}
            <div className="fin-content">
                <div className="fin-content-inner">
                    {/* FILTER BAR */}
                    <div className="fin-filter-bar">
                        <div className="fin-filter-left">
                            <h2 className="fin-section-title">{tabs.find(t => t.id === activeTab)?.label}</h2>
                            {/* <span className="fin-result-count">{filteredReports.length} document{filteredReports.length !== 1 ? "s" : ""}</span> */}
                        </div>

                        <div className="fin-filter-right">
                            {/* Search */}
                            <div className="fin-search-wrapper">
                                <SearchIcon />
                                <input
                                    type="text"
                                    placeholder="Search documents..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    className="fin-search-input"
                                />
                                {searchQuery && (
                                    <button
                                        className="fin-search-clear"
                                        onClick={() => setSearchQuery("")}
                                    >
                                        ×
                                    </button>
                                )}
                            </div>

                            {hasYearFilter && (
                                <>
                                    <div className="fin-filter-icon">
                                        <FilterIcon />
                                        <span>Filter</span>
                                    </div>
                                    <div className="fin-select-wrapper">
                                        <CalendarIcon />
                                        <select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)} className="fin-select">
                                            {uniqueYears.map(year => (
                                                <option key={year} value={year}>{year === "All" ? "All Years" : `FY ${year}`}</option>
                                            ))}
                                        </select>
                                    </div>

                                    {hasQuarterFilter && (
                                        <div className="fin-select-wrapper">
                                            <select value={selectedQuarter} onChange={(e) => setSelectedQuarter(e.target.value)} className="fin-select">
                                                {uniqueQuarters.map(q => (
                                                    <option key={q} value={q}>{q === "All" ? "All Quarters" : q}</option>
                                                ))}
                                            </select>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>

                    {/* ACTIVE FILTERS */}
                    {(selectedYear !== "All" || selectedQuarter !== "All" || searchQuery) && (
                        <div className="fin-active-filters">
                            {selectedYear !== "All" && hasYearFilter && (
                                <span className="fin-filter-chip">
                                    FY {selectedYear}
                                    <button onClick={() => setSelectedYear("All")}>×</button>
                                </span>
                            )}
                            {selectedQuarter !== "All" && hasQuarterFilter && (
                                <span className="fin-filter-chip">
                                    {selectedQuarter}
                                    <button onClick={() => setSelectedQuarter("All")}>×</button>
                                </span>
                            )}
                            {searchQuery && (
                                <span className="fin-filter-chip">
                                    Search: "{searchQuery}"
                                    <button onClick={() => setSearchQuery("")}>×</button>
                                </span>
                            )}
                            <button className="fin-clear-all" onClick={() => { setSelectedYear("All"); setSelectedQuarter("All"); setSearchQuery(""); }}>
                                Clear all
                            </button>
                        </div>
                    )}

                    {/* REPORTS */}
                    {filteredReports.length > 0 ? (
                        groupedReports && selectedYear === "All" ? (
                            <div className="fin-grouped-reports">
                                {groupedReports.map(([period, reports]) => (
                                    <div key={period} className="fin-report-group">
                                        <div className="fin-group-header">
                                            <h3 className="fin-group-title">
                                                <CalendarIcon />
                                                {period === "Other" ? "General" : `FY ${period}`}
                                            </h3>
                                            {/* <span className="fin-group-count">{reports.length} file{reports.length !== 1 ? "s" : ""}</span> */}
                                        </div>
                                        <div className="fin-reports-grid">
                                            {reports.map((report, index) => {
                                                const qColor = getQuarterColor(report.Quater);
                                                return (
                                                    <div key={index} className="fin-report-card">
                                                        <div className="fin-card-top">
                                                            <div className="fin-card-icon-wrapper">
                                                                {report.icon || <PdfIcon />}
                                                            </div>
                                                            {report.Quater && (
                                                                <span className="fin-quarter-badge" style={{ background: qColor.bg, color: qColor.text, borderColor: qColor.border }}>
                                                                    {report.Quater}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className="fin-card-body">
                                                            <h4 className="fin-card-title">{report.title}</h4>
                                                        </div>
                                                        <div className="fin-card-footer">
                                                            {report.period && <span className="fin-card-period">{report.period}</span>}
                                                            <button
                                                                className="fin-download-btn"
                                                                title="Download"
                                                                onClick={() => report.url && window.open(report.url, "_blank")}
                                                            >
                                                                <DownloadIcon />
                                                            </button>

                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="fin-reports-grid">
                                {filteredReports.map((report, index) => {
                                    const qColor = getQuarterColor(report.Quater);
                                    return (
                                        <div key={index} className="fin-report-card">
                                            <div className="fin-card-top">
                                                <div className="fin-card-icon-wrapper">
                                                    {report.icon || <PdfIcon />}
                                                </div>
                                                {report.Quater && (
                                                    <span className="fin-quarter-badge" style={{ background: qColor.bg, color: qColor.text, borderColor: qColor.border }}>
                                                        {report.Quater}
                                                    </span>
                                                )}
                                            </div>
                                            <div className="fin-card-body">
                                                <h4 className="fin-card-title">{report.title}</h4>
                                            </div>
                                            <div className="fin-card-footer">
                                                {report.period && <span className="fin-card-period">{report.period}</span>}
                                                <button
                                                    className="fin-download-btn"
                                                    title="Download"
                                                    onClick={() => report.url && window.open(report.url, "_blank")}
                                                >
                                                    <DownloadIcon />
                                                </button>

                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )
                    ) : (
                        <div className="fin-no-results">
                            <div className="fin-no-results-icon">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                                    <path d="M9 14L15 8M9 8L15 14M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#D1D5DB" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                            </div>
                            <h3>No documents found</h3>
                            <p>Try adjusting your filters to find what you're looking for.</p>
                            <button className="fin-reset-btn" onClick={() => { setSelectedYear("All"); setSelectedQuarter("All"); }}>
                                Reset Filters
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Financial;